/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Remove_Event_TitleInputs */

const en_remove_event_title = /** @type {(inputs: Remove_Event_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove Event(s)`)
};

const fr_remove_event_title = /** @type {(inputs: Remove_Event_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer Evenement(s)`)
};

const de_remove_event_title = /** @type {(inputs: Remove_Event_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignis(se) entfernen`)
};

const it_remove_event_title = /** @type {(inputs: Remove_Event_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovi evento/i`)
};

const ru_remove_event_title = /** @type {(inputs: Remove_Event_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить событие(я)`)
};

const es_remove_event_title = /** @type {(inputs: Remove_Event_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar evento(s)`)
};

const zh_cn2_remove_event_title = /** @type {(inputs: Remove_Event_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移除事件`)
};

const ja_remove_event_title = /** @type {(inputs: Remove_Event_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントを削除`)
};

const hi_remove_event_title = /** @type {(inputs: Remove_Event_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट हटाएं`)
};

const pt_pt2_remove_event_title = /** @type {(inputs: Remove_Event_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover evento(s)`)
};

/**
* | output |
* | --- |
* | "Remove Event(s)" |
*
* @param {Remove_Event_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const remove_event_title = /** @type {((inputs?: Remove_Event_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Remove_Event_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_remove_event_title(inputs)
	if (locale === "de") return de_remove_event_title(inputs)
	if (locale === "it") return it_remove_event_title(inputs)
	if (locale === "ru") return ru_remove_event_title(inputs)
	if (locale === "es") return es_remove_event_title(inputs)
	if (locale === "zh-CN") return zh_cn2_remove_event_title(inputs)
	if (locale === "ja") return ja_remove_event_title(inputs)
	if (locale === "hi") return hi_remove_event_title(inputs)
	if (locale === "pt-PT") return pt_pt2_remove_event_title(inputs)
	return en_remove_event_title(inputs)
});